import React, { useEffect, useState } from "react";
import {
  Container,
  Spinner,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  Input,
  Label,
  FormGroup,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Helmet } from "react-helmet";
import { useParams, useHistory } from "react-router-dom";
import Button from "components/Inputs/TButton";
import Client from "services/WebAPI";
import { useDispatch } from "react-redux";
import { getList } from "screens/partner/service";
import moment from "moment";
import { alertActions } from "redux/_actions";
import AlertMessage from "components/Alert";
import Tier from "./tier";
const { SearchBar } = Search;

const PopConfirm = ({ onOk }) => {
  const [modal, SetModal] = useState(false);

  const handleConfirm = () => {
    if (onOk) onOk();
    SetModal(false);
  };

  return (
    <>
      <UncontrolledTooltip target={"ammend"}>Ammend</UncontrolledTooltip>
      <Button
        id="ammend"
        onClick={() => SetModal(!modal)}
        size="sm"
        color="primary"
        outline
      >
        X
      </Button>
      <Modal isOpen={modal} toggle={() => SetModal(false)}>
        <ModalHeader
          className="confirm-modal-header"
          toggle={() => SetModal(false)}
        >
          Are you sure to ammend this invoice?
        </ModalHeader>
        <ModalBody className="confirm-modal-body">
          As a result of this action, this invoice will be ammended from the
          system.
        </ModalBody>
        <ModalFooter className="confirm-modal-footer">
          <Button color="danger" size="sm" onClick={handleConfirm}>
            <i className="far fa-trash-alt" style={{ marginRight: 5 }} />
            Ammend
          </Button>{" "}
          <Button size="sm" outline onClick={() => SetModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default function BillingHistory() {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [markPaid, setMarkPaid] = useState(false);
  const [showTier, setShowTier] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [invoiceID, setInvoiceID] = useState(null);
  const [fnLoading, setFnLoading] = useState(false);
  const history = useHistory();
  const { id, type } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchHistory();
  }, [id]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const resp = await Client.get(
        `/Billing/FetchInvocieHistory${
          id != 0
            ? `?${type === "partner" ? "partnerId" : "customerId"}=${parseInt(
                id
              )}`
            : ""
        }`
      );
      if (resp.data.status && resp.data.result) setRowData(resp.data.result);
    } catch (err) {
      console.log("err", err);
    }
    setLoading(false);
  };

  const handleConfirm = async (id) => {
    try {
      setFnLoading(true);
      const req = {
        InvoiceId: invoiceID,
        Reference: referenceId,
      };
      const resp = await Client.post("/Billing/MarkInvoiceAsPaid", req);
      if (resp.data.status) {
        setInvoiceID(null);
        setMarkPaid(false);
        setReferenceId(null);
        dispatch(alertActions.success("Successfully Updated!"));
        fetchHistory();
      }
    } catch (error) {
      console.log("error", error);
      dispatch(alertActions.error("Something went wrong"));
    }
    setFnLoading(false);
    setTimeout(() => {
      dispatch(alertActions.clear());
    }, 2500);
  };

  const handleAmmend = async (r) => {
    try {
      setFnLoading(true);
      const resp = await Client.get(
        `/Billing/ExecuteAmmendForInvoice?invoiceNumber=${r?.XeroInvoiceId}`
      );
      if (resp.data.status) {
        fetchHistory();
        dispatch(alertActions.success("Successfully ammended"));
      } else dispatch(alertActions.error("Something went wrong"));
    } catch (error) {
      console.log("error", error);
      dispatch(alertActions.error("Something went wrong"));
    }
    setFnLoading(false);
    setTimeout(() => {
      dispatch(alertActions.clear());
    }, 2500);
  };

  const columns = [
    {
      dataField: "InvoiceNumber",
      text: "Invoice",
      searchable: true,
    },
    {
      dataField: "InvoiceDate",
      text: "Invoice Date",
      classes: "common-table-column-style",
      searchable: true,
      formatter: (cell, row) => (
        <span>{moment(cell).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      dataField: "DueDate",
      text: "Due Date",
      classes: "common-table-column-style",
      searchable: true,
      formatter: (cell, row) => (
        <span>{moment(cell).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      text: "Bill To",
      classes: "common-table-column-style",
      searchable: true,
      formatter: function (cell, row) {
        let partnerA = "<Deleted>";
        if (row.PartnerId && row.Partner?.FirstName && row.Partner?.LastName)
          partnerA = row.Partner?.FirstName + " " + row.Partner?.LastName;
        if (row.CustomerId && row.Customer?.FirstName && row.Customer?.LastName)
          partnerA = row.Customer?.FirstName + " " + row.Customer?.LastName;
        return <span>{partnerA}</span>;
      },
    },
    {
      text: "Bill Type",
      classes: "common-table-column-style",
      searchable: true,
      formatter: function (cell, row) {
        let partnerA = row?.CustomerId ? "Customer" : "Partner";
        return <span>{partnerA}</span>;
      },
    },
    {
      dataField: "Quanitity",
      text: "Quantity",
      classes: "common-table-column-style",
      searchable: true,
    },
    {
      dataField: "Amount",
      text: "Amount",
      classes: "common-table-column-style",
      searchable: true,
    },
    {
      dataField: "PaymentStatus",
      text: "Status",
      classes: "common-table-column-style",
      searchable: true,
      formatter: (cell, row) => (
        <span style={{ color: cell === "Unpaid" ? "#e4535a" : "#1E8DCC" }}>
          {cell}
        </span>
      ),
    },
    {
      text: "Actions",
      classes: "common-table-column-style",
      searchable: true,
      headerStyle: { width: "240px" },
      formatter: (cell, row) => (
        <div style={{ display: "flex" }}>
          {row.PaymentStatus != "Paid" && (
            <div style={{ display: "flex", marginRight: "13px" }}>
              <UncontrolledTooltip target={"markAsPaid"}>
                Mark as paid
              </UncontrolledTooltip>
              <Button
                id="markAsPaid"
                size="sm"
                color="primary"
                outline
                onClick={() => {
                  setMarkPaid(true);
                  setInvoiceID(row.Id);
                }}
              >
                <i class="fas fa-money-bill"></i>
              </Button>
              <PopConfirm onOk={() => handleAmmend(row)} />
            </div>
          )}
          {row?.StripeIntentId && (
            <div style={{ marginRight: "13px" }}>
              <UncontrolledTooltip target={"intend"}>
                Go to payment intend
              </UncontrolledTooltip>
              <Button
                id="intend"
                size="sm"
                color="primary"
                outline
                onClick={() =>
                  window.open(
                    `https://dashboard.stripe.com/test/payments/${row?.StripeIntentId}`
                  )
                }
              >
                <i class="fa fa-credit-card"></i>
              </Button>
            </div>
          )}
          {row?.XeroInvoiceId && (
            <div>
              <UncontrolledTooltip target={"xeroInvoice"}>
                Go to Xero Invoice
              </UncontrolledTooltip>
              <Button
                id="xeroInvoice"
                size="sm"
                color="primary"
                outline
                onClick={() =>
                  window.open(
                    `https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=${row?.XeroInvoiceId}`
                  )
                }
              >
                <i class="fa fa-file-invoice"></i>
              </Button>
            </div>
          )}
        </div>
      ),
    },
  ];

  const paginationOptions = {
    custom: true,
    withFirstAndLast: true,
    totalSize: rowData.length,
  };
  return (
    <div>
      {" "}
      <Container className="container-modal" fluid>
        <div className="common-headers">
          <Button
            className="common-btn-back mr-2"
            outline
            onClick={() => history.go(-1)}
          >
            <i className="fas fa-chevron-left" />
          </Button>
          Manage Billing
        </div>
        <Helmet>
          <title>{"Billing"}</title>
        </Helmet>
        {!showTier && <AlertMessage />}
        <Row>
          <div className="col">
            <ToolkitProvider
              keyField="PartnerId"
              data={rowData}
              columns={columns}
              search
            >
              {(props) => (
                <PaginationProvider
                  pagination={paginationFactory(paginationOptions)}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      <Row style={{ marginBottom: 6 }}>
                        <Col
                          xs="5"
                          className="local-text"
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Entries per page :
                          <SizePerPageDropdownStandalone
                            className="common-page-size-selector ml-2"
                            {...paginationProps}
                          />
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <UncontrolledTooltip target={"tier"}>
                            Tier Management
                          </UncontrolledTooltip>
                          <Button
                            id="tier"
                            color="primary"
                            outline
                            onClick={() => {
                              setShowTier(true);
                            }}
                          >
                            <i class="fas fa-level-up-alt mr-2" /> Tiers
                          </Button>
                          <SearchBar
                            className="table-search-input"
                            {...props.searchProps}
                          />
                        </Col>
                      </Row>
                      <BootstrapTable
                        hover
                        bordered={false}
                        //rowEvents={rowEvents}
                        noDataIndication={
                          loading ? (
                            <Spinner type="grow" color="primary" />
                          ) : (
                            "No Data"
                          )
                        }
                        headerWrapperClasses="table-header-light"
                        bodyClasses="clickable-table-row"
                        {...props.baseProps}
                        {...paginationTableProps}
                      />
                      <Row style={{ marginTop: 10 }}>
                        <Col>
                          <PaginationTotalStandalone {...paginationProps} />
                        </Col>
                        <Col>
                          <PaginationListStandalone {...paginationProps} />
                        </Col>
                      </Row>
                    </div>
                  )}
                </PaginationProvider>
              )}
            </ToolkitProvider>
          </div>
        </Row>
        <Modal
          isOpen={showTier}
          style={{ minWidth: "70%" }}
          toggle={() => {
            setShowTier(false);
          }}
        >
          <ModalHeader>Tier Management</ModalHeader>
          <ModalBody className="confirm-modal-body">
            <Tier />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={markPaid}
          toggle={() => {
            setMarkPaid(false);
            setReferenceId(null);
            setInvoiceID(null);
          }}
        >
          <ModalHeader>Mark As Paid</ModalHeader>
          <ModalBody className="confirm-modal-body">
            <FormGroup>
              <Label for="commitment">Reference Note:</Label>
              <Input
                id="referenceId"
                value={referenceId}
                onChange={(e) => setReferenceId(e.target.value)}
                type="text"
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter className="confirm-modal-footer">
            <Button color="primary" size="sm" onClick={handleConfirm}>
              <i className="fas fa-save" style={{ marginRight: 5 }} />
              Continue
            </Button>
            <Button
              size="sm"
              outline
              onClick={() => {
                setMarkPaid(false);
                setReferenceId(null);
                setInvoiceID(null);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={fnLoading}>
          <ModalBody style={{ minHeight: "75px" }}>
            <Spinner
              style={{
                position: "absolute",
                left: "50%",
                transform: "transform: translate(-50%, -50%)",
              }}
            />
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
}
